import { Dispatch } from 'react';
import { PricingApi } from '../../../api/api.apiclient';
import { OneWayFeeRequest } from '../../../api/pricing/pricing.types';
import {
  ADD_ONE_WAY_FEE,
  ADD_ONE_WAY_FEES,
  AddOneWayFeeAction,
  AddOneWayFeesAction,
  LIST_ALL_ONE_WAY_FEES
} from '../types/onewayfees.types';

export const getOneWayFeeList = () => async (dispatch: Dispatch<any>) => {
  const response = await PricingApi.OneWayFees.listAllOneWayFees(0);
  dispatch({
    type: LIST_ALL_ONE_WAY_FEES,
    payload: {
      oneWayFees: response
    }
  });
};


export const addOneWayFees = (oneWayFees: OneWayFeeRequest[]) => async (dispatch: Dispatch<AddOneWayFeesAction>) => {
  const response = await PricingApi.OneWayFees.addOneWayFees(oneWayFees);

  dispatch({
    type: ADD_ONE_WAY_FEES,
    payload: {
      oneWayFees: response.data
    }
  });
};
